import { Component, OnInit, Input, AfterViewInit, OnChanges } from '@angular/core';
import { environment } from '@environments/environment';
import { INDRAPlaneSeat } from '@ibe.models/seatmap.indra.model.lib';
import * as _ from 'lodash';

import { INDRACurrencyService } from '@ibe.services/currency.indra.service';
import { INDRAIbeAdminService } from '@ibe.services/ibeadmin.indra.service';

@Component({
	selector: 'app-seatmap-seat',
	templateUrl: './seatmap-seat.indra.component.html',
	styleUrls: ['./seatmap-seat.component.scss']
})
export class INDRASeatmapSeatComponent implements AfterViewInit, OnChanges {

	@Input() seat: INDRAPlaneSeat;
	@Input() cabin;
	@Input() seatStyles;

	@Input() seatPassenger;
	@Input() hasBusinessCabin: boolean;
	@Input() hasIcon: boolean;
	@Input() seatIcon: string;
	@Input() seatFeatures;

	price = '0.00';
	mnbPrice = '0.00';

	ZERO_PRICE: any;
	currency: string;

	constructor(protected currencyService: INDRACurrencyService,
		protected ibeAdminService: INDRAIbeAdminService) {
		this.currency = this.currencyService.INDRA_getCurrencySymbol().unit;
		this.ZERO_PRICE = this.currencyService.INDRA_formatCash(0);
	}

	ngAfterViewInit() {
		this.INDRA_getSeatPrices();
	}

	ngOnChanges() {
		this.INDRA_getSeatPrices();
	}

	INDRA_getSeatPrices(): void {
		if (!_.isEmpty(this.seat.prices) && !_.isEmpty(this.seat.prices[0])) {
			const seatPrice = this.seat.prices[0];
			this.price = seatPrice && seatPrice.price
				? this.currencyService.INDRA_formatCash(seatPrice.price)
				: this.ZERO_PRICE;
			this.mnbPrice = seatPrice && seatPrice.mnbPrice
				? this.currencyService.INDRA_formatCash(seatPrice.mnbPrice)
				: this.ZERO_PRICE;
		} else {
			this.price = this.ZERO_PRICE;
			this.mnbPrice = this.ZERO_PRICE;
		}
	}

	INDRA_tooltipSeat() {
		// if (!this.seat['empty']) {
		// 	let zone = this.hasBusinessCabin ? this.INDRA_getTranslation('addMoreSidebars.seatmap.text.executiveSeat') : this.INDRA_getTranslation('addMoreSidebars.seatmap.text.standardSeat');

		// 	if (!this.hasBusinessCabin && this.seat.preferredSeat) {
		// 		zone = this.INDRA_getTranslation('addMoreSidebars.seatmap.text.comfortSeat');
		// 	}
		// 	let seatCodeLabel =  `${this.seat.seatCode} - ${zone} ${this.price}${this.currency}<br/><br/>`;
		// 	let seatInclusionsLabel = this.INDRA_getSeatFeatures() ? this.INDRA_getSeatFeatures().replace(/,/g, '') : this.INDRA_getSeatFeatures(); 
		// 	return seatCodeLabel + seatInclusionsLabel;
		// } else {
		// 	return null;
		// }

		if (!this.seat['empty']) {
			let zone = '';
			let type = '';
			
			if (!this.hasBusinessCabin) {
				if (this.seat.exit) {
					zone = this.INDRA_getTranslation('addMoreSidebars.seatmap.text.exitRow');
					if (this.seat.preferredSeat) {
						type = 'economyExtra'
					} else {
						type = 'economy';
					}
				} else {
					if (this.seat.preferredSeat) {
						type = 'economyExtra';
						if (this.seat.extraLegSpace) {
							zone = this.INDRA_getTranslation('addMoreSidebars.seatmap.text.legSpace');
						} else {
							zone = this.INDRA_getTranslation('addMoreSidebars.seatmap.text.comfort');
						}
					} else {
						zone = this.INDRA_getTranslation('addMoreSidebars.seatmap.text.standard');
						type = 'economy';
					}
				}
			} else {
				// Business Cabin
				zone = this.INDRA_getTranslation('addMoreSidebars.seatmap.text.executive');
				type = 'business';
			}

			let seatCodeLabel = "";
			if (this.mnbPrice != this.ZERO_PRICE) {
				seatCodeLabel = `${this.seat.seatCode} - ${zone} <s>${this.mnbPrice}${this.currency}</s> <b>${this.price}${this.currency}</b>`
			} else {
				seatCodeLabel = `${this.seat.seatCode} - ${zone} ${this.price}${this.currency}`;
			}
			return seatCodeLabel;
		} else {
			return null;
		}
	}

	INDRA_getSeatFeatures() {
		let seatFeaturesListLabels = [];
		if (this.seatFeatures && this.seatFeatures.length > 0) {
			for (let feature of this.seatFeatures) {
				seatFeaturesListLabels.push(`<li>&#10003; ${this.INDRA_getTranslation(feature)}</li>`);
			}
			return `<ul>`+seatFeaturesListLabels+`</ul>`;
		}
	}

	INDRA_getTranslation(key: string): string {
		return this.ibeAdminService.getTranslationValue(key);
	}

}
